import React, {useEffect} from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import axios from 'axios';
import SignUp from "./components/Authentication/SignUp";
import ChangePhone from "./components/candidate/ChangePhone";
import UpdateEmail from "./components/candidate/UpdateEmail";
import Footer from "./components/Footer";
import Header from "./components/Header";
import About from "./components/pages/About";
import CandidatePage from "./components/pages/CandidatePage"
import AppliedJobs from "./components/pages/candidate/AppliedJobs";
import CandidateDashboard from "./components/pages/candidate/CandidateDashboard";
import CandidateMsgDashboard from "./components/pages/candidate/CandidateMsgDashboard";
import CandidateProfile from "./components/pages/candidate/CandidateProfile";
import CandidateResume from "./components/pages/candidate/CandidateResume";
import CV_Manager from "./components/pages/candidate/CV_Manager";
import JobAlerts from "./components/pages/candidate/JobAlerts";
import SavedJobs from "./components/pages/SavedJobs";
import Setting from "./components/pages/candidate/Setting";
import SortListedJobs from "./components/pages/candidate/SortListedJobs";
import Contact from "./components/pages/Contact";
import DeleteProfile from "./components/pages/DeleteProfile";
import CompanyProfile from "./components/pages/employer/CompanyProfile";
import EmployerDashboard from "./components/pages/employer/EmployerDashboard";
import EmployerMsgDashboard from "./components/pages/employer/EmployerMsgDashboard";
import ManageJobs from "./components/pages/employer/ManageJobs";
import PostAJob from "./components/pages/employer/PostAJob";
import ResumeAlerts from "./components/pages/employer/ResumeAlerts";
import SortListResumes from "./components/pages/employer/SortListResumes";
import HomePage from "./components/pages/HomePage";
import JobSearchList from "./components/pages/JobSearchList";
import UpdatePassword from "./components/candidate/UpdatePassword";
import JobDetails from "./components/Job/JobDetails";
import Login from "./components/pages/Login";
import Logout from "./components/pages/Logout";
import OurTeam from "./components/pages/OurTeam";
import Testimoniall from "./components/pages/Testimonial/Testimoniall";
import SignupCompany from "./components/SignupCompany";
import ProtectedRoute from "./ProtectedRoute";
import CompanyDashboard from "./components/pages/Company/CompanyDashboard"
import ContactUs from "./components/pages/ContactUs";
import ComplaintPage from "./components/pages/Complaint/ComplaintPage";
import JobList from "./components/Job/JobList";
import ForgetPassword from "./components/Authentication/ForgetPassword";
import TermsOfService from "./components/pages/TermsOfService";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import JobDetailsPage from "./components/pages/employer/JobDetailsPage";
import Faq from "./components/FAQ/Faq";
import ManageHr from "./components/pages/employer/ManageHr";
import EmployerDetails from "./components/pages/Company/EmployerDetails"
import CandidateReview from "./components/pages/candidate/CandidateReview";
import ScrollToTop from "./components/ScrollToTop";
import ManageCandidates from "./components/pages/employer/ManageCandidates";
import ShortlistedCandidates from "./components/pages/employer/ShortlistedCandidates";
import Error404 from "./components/pages/Error404";
import Category from "./components/pages/Category";
import ManageInterviews from "./components/pages/employer/ManageInterviews";

const App = () => {
  //  temp code to run server continuously comment this code before deployment
  //  const callApiQsList = async () => {
  //   try {
  //     const url = process.env.REACT_APP_API_URL + 'settings/allsettings';
  //     const response = await axios.get(url);
  //   }
  //   catch (error) { console.log(error); }
  // }

  // useEffect(() => {
  //   setInterval(() => callApiQsList(), 30000)
  // }, []) 

  return (
    <BrowserRouter>
      <ScrollToTop /> 
      <Header />
      <Routes>
        {/* Common Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/testimonials" element={<Testimoniall />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/deleteaccount" element={<DeleteProfile />} />
        <Route path="/jobsearch" element={<JobSearchList />} />
        <Route path="/jobs" element={<JobList />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/termandconditions" element={<TermsOfService />} />
        <Route path="/ourcategory" element={<Category />} />
        <Route path="/saved-jobs" element={<SavedJobs />} />

        {/* Candidate Routes */}
        <Route path="/candidatedashboard" element={<CandidateDashboard />} />
        <Route path="/myprofile" element={<CandidateProfile />} />
        <Route path="/candidate-resume" element={<CandidateResume />} />
        <Route path="/candidate-applied-jobs" element={<AppliedJobs />} />
        <Route path="/candidate-sortlisted-jobs" element={<SortListedJobs />} />
        <Route path="/candidate-cv-manager" element={<CV_Manager />} />
        <Route
          path="/candidate-msg-dashboard"
          element={<CandidateMsgDashboard />}
        />
        <Route path="/candidate-job-alerts" element={<JobAlerts />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/complaints" element={<ComplaintPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/job-details/:jobId" element={<JobDetails/>}/>
        <Route path="/updateuserpassword" element={<UpdatePassword />} />
        <Route path="/changeuserphone" element={<ChangePhone />} />
        <Route path="/updateuseremail" element={<UpdateEmail />} />
        {/* Employer Routes */}
        <Route path="/employerdashboard" element={<EmployerDashboard />} />
        <Route path="/manage-candidates" element={<ManageCandidates />} />
        <Route path="/company-profile" element={<CompanyProfile />} />
        <Route path="/candidatePage" element={<CandidatePage />} />

        <Route path="/postjob" element={<PostAJob />} />
        <Route path="/managejobs" element={<ManageJobs />} />
        <Route path="/sortlistedresumes" element={<SortListResumes />} />
        <Route
          path="/employer-msg-dashboard"
          element={<EmployerMsgDashboard />}
        />
        <Route path="/resume-alert" element={<ResumeAlerts />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/register-employer" element={<SignupCompany />} />
        <Route path="/job-details-page" element={<JobDetailsPage />} />
        <Route path="/manage-hr" element={<ManageHr />} />
        <Route path="/manage-interviews" element={<ManageInterviews />} />
        <Route path="/shortlisted-candidates" element={<ShortlistedCandidates />} />
        <Route path="/candidate-review" element={<CandidateReview />} />
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy/>}></Route>

        {/* Candidate Routes */}
        <Route
          path="/candidatedashboard"
          element={
            <ProtectedRoute
              element={<CandidateDashboard />}
              allowedRoles={["candidate"]}
            />
          }
        />
        <Route
              path="/candidatePage"
              element={
              <ProtectedRoute
                 element={<CandidatePage />}
                 allowedRoles={["employer"]}
                    />
                    }
                  />

        {/* Employer Routes */}
        <Route
          path="/employerdashboard"
          element={
            <ProtectedRoute
              element={<EmployerDashboard />}
              allowedRoles={["employer"]}
            />
          }
        />

        {/* Company Route  */}
        <Route path="/companies" element={<CompanyDashboard/>} />
        <Route path="/employers/employer-details/:id" element={<EmployerDetails/>}/>


      {/* Route for footers */}
      <Route path="/faq" element={<Faq/>}/>
      <Route path="*" element={<Error404/>}/>
      </Routes>
      <Footer />

    </BrowserRouter>
  );
};

export default App;
